import type { CollectionModelFieldTrueSize } from '@ikegps/core-shared';
import { addStyles, DefaultTheme } from '../../../components/theme';
import type { MithrilVNode } from '../../../mithril';
import { m } from '../../../mithril';
import { Services } from '../../../services';
import { CaptureThumbnail } from '../../capture.thumbnail/capture.thumbnail';
import type { CollectionEditCtrl } from '../collection.view.ctrl';
import type { CollectionFieldView } from './field.view';

export const CSS = {
	capture: 'c-TrueSize__capture',
};

addStyles({
	[CSS.capture]: {
		padding: DefaultTheme.space(1),
	},
});

export const TrueSizeView: CollectionFieldView<CollectionModelFieldTrueSize> = {
	viewInline(field: CollectionModelFieldTrueSize): string {
		const captures = field.getCaptures();
		if (captures.length > 0) {
			return String(captures.length);
		}
		return '';
	},

	hasDetail(field: CollectionModelFieldTrueSize) {
		return field.getCaptures().length > 0;
	},

	viewDetail(field: CollectionModelFieldTrueSize): MithrilVNode {
		const captures: MithrilVNode[] = [];
		const className = CSS.capture;
		const imageCtx = { truesize: true, className, title: '' };
		const collection = field.collection;
		for (const capture of field.getCaptures()) {
			imageCtx.title = Services.DateTime.formatDateTime(capture.collectedAt.iso);
			const dom = CaptureThumbnail.view(collection, capture, imageCtx);
			captures.push(dom);
		}
		return m.fragment({}, captures);
	},

	viewEdit(field: CollectionModelFieldTrueSize, state: CollectionEditCtrl): MithrilVNode | string {
		return TrueSizeView.viewInline(field, state);
	},

	hasClear(field: CollectionModelFieldTrueSize): boolean {
		return false;
	},
};
